module.exports = __webpack_public_path__ + "img/introductionToSafetyStudies_sign.e5eeee61.png";